(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-gallery"] && !Shopify.designMode) return;
  try {
    
  window.ArticleListComponent = function () {
    return {
      init: function () {
        const swiper = new Swiper(this.$refs.swiperWrapper, {
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 5,
            },
          },
          slidesPerView: 1.4,
          spaceBetween: 10,
          scrollbar: {
            el: this.$refs.swiperScrollbar,
            draggable: true,
            snapOnRelease: false,
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        const prevButtons = this.$el.querySelectorAll('[data-navigation-button="prev"]');
        const nextButtons = this.$el.querySelectorAll('[data-navigation-button="next"]');

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slideNext();
          });
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-items"] && !Shopify.designMode) return;
  try {
    
  window.CartComponent = function (discount) {
    return {
      discountCode: '',
      isApplyingDiscount: false,
      isApplyDiscountSuccess: false,
      isApplyDiscountError: false,
      applyDiscountErrorMessage: '',
      // remove discount
      removeDiscountMutation: null,
      isRemovingDiscount: false,
      isRemovingDiscountSuccess: false,
      isRemovingDiscountError: false,
      removeDiscountErrorMessage: '',
      // shipping estimator
      shippingRates: [],
      get minimumShippingRate() {
        if (!this.shippingRates.length) {
          return null;
        }
        return this.shippingRates.reduce((min, rate) => (rate.price < min.price ? rate : min), this.shippingRates[0]);
      },
      get estimatedHandlingShipping() {
        const shippingRate = this.minimumShippingRate;
        if (!shippingRate) {
          return null;
        }
        if (shippingRate.price === 0) {
          return 'Free';
        }

        // shipping rate is using the shop's default currency, convert to the current currency
        const isCurrencyCodeTheSame = shippingRate.currency === window.Shopify.currency.active;
        const price = isCurrencyCodeTheSame ? shippingRate.price : shippingRate.price * window.Shopify.currency.rate;
        return new Intl.NumberFormat(window.Shopify.locale, {
          style: 'currency',
          currency: window.Shopify.currency.active,
        }).format(price);
      },
      get estimatedDeliveryDate() {
        const shippingRate = this.minimumShippingRate;
        if (!shippingRate?.delivery_date) {
          return null;
        }
        return new Date(shippingRate.delivery_date).toLocaleDateString(window.Shopify.locale, {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      },
      applyDiscount: function (discountCode) {
        if (!discountCode) {
          return;
        }
        if (!this.$store.cart.data.discount_codes.map((code) => code.code).includes(discountCode)) {
          this.isApplyingDiscount = true;
          this.isApplyingDiscountError = false;
          this.applyDiscountErrorMessage = '';
          this.isApplyingDiscountSuccess = false;
          this.$store.cart.updateCartMutation.mutate(
            {
              discount: [...this.$store.cart.data.discount_codes.map((code) => code.code), discountCode].join(','),
            },
            {
              onSuccess: (data) => {
                this.isApplyingDiscountSuccess = true;
                this.$store.cart.data = data;
                this.discountCode = '';
              },
              onError: (error) => {
                this.isApplyingDiscountError = true;
                this.applyDiscountErrorMessage = error.message;
              },
              onSettled: () => {
                this.isApplyingDiscount = false;
              },
            },
          );
        }
      },
      removeDiscount: function (discountCode) {
        if (this.$store.cart.data.discount_codes.map((code) => code.code).includes(discountCode)) {
          this.isRemovingDiscount = true;
          this.isRemovingDiscountError = false;
          this.removeDiscountErrorMessage = '';
          this.isRemovingDiscountSuccess = false;
          this.$store.cart.updateCartMutation.mutate(
            {
              discount: this.$store.cart.data.discount_codes
                .filter((code) => code.code !== discountCode)
                .map((code) => code.code)
                .join(','),
            },
            {
              onSuccess: (data) => {
                this.isRemovingDiscountSuccess = true;
                this.$store.cart.data = data;
              },
              onError: (error) => {
                this.isRemovingDiscountError = true;
                this.removeDiscountErrorMessage = error.message;
              },
              onSettled: () => {
                this.isRemovingDiscount = false;
              },
            },
          );
        }
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["communication-settings-section"] && !Shopify.designMode) return;
  try {
    
  window.CommunicationSettingsSectionComponent = function () {
    return {
      activeMenuItem: 'communication_settings',
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-page-title"] && !Shopify.designMode) return;
  try {
    
  window.ContentPageSummary = function () {
    return {
      links: [],
      init() {
        this.refresh();
      },
      refresh() {
        this.links = Array.from(document.querySelectorAll('[data-content-page-heading]'))
          .filter((element) => element.id && element.dataset.contentPageHeading.trim())
          .map((element) => ({
            id: element.id,
            title: element.dataset.contentPageHeading.replace(/\s+/g, ' ').trim(),
          }));
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-activities"] && !Shopify.designMode) return;
  try {
    
  window.FeaturedActivitiesComponent = function () {
    return {
      mouseXPercent: 0,
      scrollPercent: 0,
      translateXRange: 0,
      scaleFactor: 0.2,
      hoveredItemIndex: null,
      hoverTimeout: null,
      titlesData: [],
      activeScale: 2,
      activeMobileIndex: null,
      swiperInstance: null,
      mobileActivityLinks: [],
      init() {
        this.$nextTick(() => {
          this.onScroll();
          const titles = this.$refs.row.querySelectorAll('a');
          titles.forEach((el) => {
            this.titlesData.push({ width: el.offsetWidth });
          });
          this.mobileActivityLinks = Array.from(this.$refs.rowMobile.querySelectorAll('a'));
          if (this.$store.breakpoints.isMobile) this.initMobileSwiper();
        });

        this.$watch('$store.breakpoints.isMobile', (isMobile) => {
          if (isMobile) {
            this.$nextTick(() => this.initMobileSwiper());
          } else {
            this.destroyMobileSwiper();
          }
        });
      },
      initMobileSwiper() {
        if (this.swiperInstance || !this.$store.breakpoints.isMobile) return;

        const detectActive = (swiper) => {
          const containerMid = swiper.el.offsetWidth / 2;
          let closestIndex = 0;
          let closestDist = Infinity;

          swiper.slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + swiper.translate + slide.offsetWidth / 2;
            const dist = Math.abs(slideCenter - containerMid);
            if (dist < closestDist) {
              closestDist = dist;
              closestIndex = index;
            }
          });

          this.activeMobileIndex = closestIndex;
        };

        this.swiperInstance = new Swiper(this.$refs.rowContainerMobile, {
          touchEventsTarget: 'container',
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 60,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          on: {
            afterInit: detectActive,
            progress: detectActive,
          },
        });
      },
      destroyMobileSwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
        this.activeMobileIndex = null;
      },
      destroy() {
        this.destroyMobileSwiper();
      },
      onScroll() {
        const rect = this.$refs.container.getBoundingClientRect();
        const vh = window.innerHeight;

        // Start zoom when section top is at 75% of viewport
        const startPoint = vh * 0.75;
        // End zoom when section bottom hits the bottom of viewport
        const endPoint = vh - rect.height;

        let p = (startPoint - rect.top) / (startPoint - endPoint);
        this.scrollPercent = Math.max(0, Math.min(1, p));
      },
      onHover(index) {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          this.hoveredItemIndex = index;
        }, 30); // 30ms debounce for smoother intent
      },
      isMobile() {
        return this.$store.breakpoints.isMobile;
      },
      getActiveMobileLink() {
        if (this.activeMobileIndex === null) return null;
        return this.mobileActivityLinks[this.activeMobileIndex] || null;
      },
      goToMobileActivity(link) {
        if (!link) return;
        window.location.href = link.href;
      },
      onMobileSectionClick() {
        if (!this.isMobile()) return;

        this.goToMobileActivity(this.getActiveMobileLink());
      },
      centerMobileActivity(index) {
        const swiper = this.swiperInstance;
        if (!swiper || swiper.destroyed || !swiper.slides[index]) return;

        swiper.slideTo(index, 300);
        this.activeMobileIndex = index;
      },
      onMobileActivityClick(e, index) {
        if (this.activeMobileIndex === index) {
          this.goToMobileActivity(e.currentTarget);
          return;
        }

        this.centerMobileActivity(index);
      },
      getStyle(index) {
        if (this.hoveredItemIndex === null || this.titlesData.length === 0) {
          return { transform: 'translateX(0) scale(1)' };
        }

        const isHovered = this.hoveredItemIndex === index;
        const scale = isHovered ? this.activeScale : 1;

        let tx = 0;
        const hoveredWidth = this.titlesData[this.hoveredItemIndex].width;
        // Calculate the extra width added by the scale
        const extraWidth = (hoveredWidth * this.activeScale - hoveredWidth) / 2;

        // Shift neighbors left/right based on the hovered item
        if (index < this.hoveredItemIndex) {
          tx = -extraWidth;
        } else if (index > this.hoveredItemIndex) {
          tx = extraWidth;
        }

        return {
          transform: `translateX(${tx}px) scale(${scale})`,
          zIndex: isHovered ? 20 : 10,
          pointerEvents: 'auto',
        };
      },
      onMouseMove(e) {
        const rowContainerWidth = this.$refs.rowContainer.getBoundingClientRect().width;
        const rect = this.$refs.container.getBoundingClientRect();

        const widthDifference = rowContainerWidth - rect.width;
        this.translateXRange = widthDifference / 2 + window.innerWidth * 0.2;

        const xPos = e.clientX / window.innerWidth;
        // Normalize mouse position to range [-1, 1] and apply user's 0.25 multiplier
        this.mouseXPercent = (xPos - 0.5) * 0.25;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pages"] && !Shopify.designMode) return;
  try {
    
  window.PageListComponent = function () {
    return {
      init: function () {
        const swiper = new Swiper(this.$refs.swiperWrapper, {
          slidesPerView: 1.2,
          spaceBetween: 10,
          scrollbar: {
            el: this.$refs.swiperScrollbar,
            draggable: true,
            snapOnRelease: false,
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        const prevButtons = this.$el.querySelectorAll('[data-navigation-button="prev"]');
        const nextButtons = this.$el.querySelectorAll('[data-navigation-button="next"]');

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slideNext();
          });
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  window.FooterComponent = function () {
    return {
      init: function () {
        const benefits = this.$refs.benefitsSwiper.querySelectorAll('.swiper-slide');
        const numBenefits = benefits.length;
        const shouldLoop = numBenefits > 3;
        new Swiper(this.$refs.benefitsSwiper, {
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
          },
          slidesPerView: 1,
          allowTouchMove: false,
          loop: shouldLoop,
          autoplay: {
            enabled: shouldLoop,
            delay: 4000,
            disableOnInteraction: false,
          },
          speed: 1000,
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  window.HeaderComponent = function () {
    return {
      headerTranslateY: 0,
      // Whether to animate the `transform` property. We only enable this around
      // mode flips (e.g. secondary-only -> pdp-contextual-only). During
      // continuous scroll-follow modes (default-scroll / plp-hidden) the
      // header tracks scrollY directly and transitioning would just make
      // the header lag 300ms behind the scroll.
      animateHeaderTransform: false,
      init: function () {
        const header = this.$refs.header;
        const primaryNavigation = this.$refs.primaryNavigation;
        const secondaryNavigation = this.$refs.secondaryNavigation;

        // Relocate the <header> out of Shopify's section wrappers and into
        // <body> directly. Shopify wraps each section in a <div> that is
        // only as tall as its content, which becomes the sticky element's
        // containing block. We used to work around this with
        // `display: contents` on the wrappers, but iOS Chrome (WKWebView)
        // has a bug where it still treats a `display: contents` ancestor
        // as a containing block for sticky — the header ends up with 0 px
        // of travel and visually stops sticking the instant you scroll.
        // Moving the header into <body> gives sticky the whole document as
        // its scrolling container, which works reliably across every
        // browser (including iOS Chrome) without any CSS gymnastics.
        if (header.parentElement !== document.body) {
          document.body.prepend(header);
        }

        if (primaryNavigation) {
          const primaryNavigationLinks = primaryNavigation.querySelectorAll('a');
          primaryNavigationLinks.forEach((link) => {
            const isActive = link.href === window.location.href;
            link.classList.toggle('!text-summit-yellow', isActive);
          });
        }

        const secondaryNavigationHeight = secondaryNavigation.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--secondary-navigation-height', `${secondaryNavigationHeight}px`);
        const headerHeight = header.getBoundingClientRect().height;
        const primaryNavigationHeight = this.$refs.primaryNavigationContainer.getBoundingClientRect().height;
        document.body.style.setProperty('--header-height', `${headerHeight}px`);

        // Stacked contextual bar on PDP (add-to-cart). It lives below the
        // secondary nav with a 1px separator, so the stacked height is
        // secondary + 1 + add-to-cart. We measure the add-to-cart element
        // lazily because it is rendered via x-show and might be hidden.
        const getAddToCartHeight = () => {
          const el = this.$refs.headerAddToCart;
          if (!el) return 0;
          // Use scrollHeight so we still get the intrinsic height while x-show
          // is toggling display: none.
          return el.getBoundingClientRect().height || el.scrollHeight || 0;
        };

        // Direction tracking with a small dead zone so tiny wheel/trackpad
        // jitter doesn't flip the nav back and forth.
        const SCROLL_DIRECTION_THRESHOLD = 5;
        let scrollDirection = 'up';
        let lastScrollYForDirection = window.scrollY ?? 0;

        // Follow-modes update `transform` on every scroll tick, so we don't want a
        // CSS transition lagging behind the cursor in those cases.
        const FOLLOW_MODES = new Set(['default-scroll', 'plp-hidden']);
        let previousMode = null;
        let animateResetTimer = null;

        const onScroll = (progress, info) => {
          const scrollY = info?.y?.current ?? window.scrollY ?? 0;
          const viewportHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          // Small tolerance to account for sub-pixel rounding on some browsers/zooms.
          const atBottom = scrollY + viewportHeight >= documentHeight - 1;
          const atTop = scrollY <= 0;

          const delta = scrollY - lastScrollYForDirection;
          if (Math.abs(delta) > SCROLL_DIRECTION_THRESHOLD) {
            scrollDirection = delta > 0 ? 'down' : 'up';
            lastScrollYForDirection = scrollY;
          }

          // The "main nav" (secondary nav bar) is substituted by a contextual
          // sticky bar when:
          // - PLP: the user is past the row filter (filters take the top slot),
          //   and the row filter has not scrolled off the top yet (if it has,
          //   the products-listing section is behind us and the contextual
          //   bar is effectively gone).
          // - PDP: the product page has flipped on the header add-to-cart bar
          const pastRowFilter =
            this.$store.hasRowFilter &&
            scrollY + secondaryNavigationHeight > this.$store.distanceFromRowFilterTopToPageTop &&
            !this.$store.settings.rowFilterExited;
          const pdpAddToCartActive = !!this.$store.product?.showHeaderAddToCart;
          const contextualBarActive = pastRowFilter || pdpAddToCartActive;
          const scrollingUp = scrollDirection === 'up';

          // Resolve the header display mode. We use an explicit state machine
          // to keep the translateY offset + CSS variable logic in one place.
          //   full                  -> primary + secondary [+ separator + add-to-cart on PDP]
          //   secondary-only        -> primary hidden; secondary [+ separator + add-to-cart on PDP]
          //   pdp-contextual-only   -> only add-to-cart visible at top
          //   plp-hidden            -> whole header slid off-screen (row filter takes over)
          //   default-scroll        -> linear primary-nav hide based on scrollY
          let mode;
          if (atTop || atBottom) {
            mode = 'full';
          } else if (contextualBarActive && scrollingUp) {
            mode = 'secondary-only';
          } else if (pastRowFilter) {
            mode = 'plp-hidden';
          } else if (pdpAddToCartActive) {
            mode = 'pdp-contextual-only';
          } else {
            mode = 'default-scroll';
          }

          // The main nav (secondary bar) is considered "revealed" whenever it
          // is showing above a contextual bar. Other components (PLP row
          // filter, product finder) read this off the settings store to drop
          // their sticky offset below the secondary nav.
          const mainNavRevealed =
            mode === 'full' || mode === 'secondary-only' || mode === 'default-scroll';
          this.$store.settings.mainNavRevealed = mainNavRevealed;

          // Mode-flip based transform animation: enable the CSS transition briefly
          // so the element smoothly slides to the new position, then turn it
          // off again when we land in a follow-mode so further scroll ticks
          // don't drag the header behind the viewport.
          if (mode !== previousMode) {
            this.animateHeaderTransform = true;
            clearTimeout(animateResetTimer);
            if (FOLLOW_MODES.has(mode)) {
              animateResetTimer = setTimeout(() => {
                this.animateHeaderTransform = false;
              }, 320);
            }
            previousMode = mode;
          }

          // Hide the header via translateY. The fixed overlays that need to
          // stay viewport-relative are teleported out of the header subtree.
          const addToCartHeight = pdpAddToCartActive ? getAddToCartHeight() : 0;
          let offsetY;
          switch (mode) {
            case 'full':
              offsetY = 0;
              break;
            case 'secondary-only':
              offsetY = -primaryNavigationHeight;
              break;
            case 'pdp-contextual-only':
              // Hide primary + secondary + separator so the add-to-cart bar
              // sits at the top of the viewport.
              offsetY = -primaryNavigationHeight - secondaryNavigationHeight - 1;
              break;
            case 'plp-hidden':
              // Fixed offset that fully hides primary + secondary. Using a
              // static value (rather than one that tracks scrollY) lets the
              // CSS transition complete in a clean 300ms slide, matching the
              // row filter's snap to top:0 instead of lagging behind it.
              offsetY = -primaryNavigationHeight - secondaryNavigationHeight;
              break;
            case 'default-scroll':
            default:
              offsetY = -Math.min(Math.max(scrollY, 0), primaryNavigationHeight);
              break;
          }
          this.headerTranslateY = offsetY;

          // Keep the dynamic CSS variables in sync with the mode, so sticky
          // elements that use them (product actions, mobile menu overlay,
          // user page title, etc.) remain correctly positioned.
          let currentPrimaryNavigationHeight;
          let currentHeaderHeight;
          switch (mode) {
            case 'full':
              currentPrimaryNavigationHeight = primaryNavigationHeight;
              currentHeaderHeight = pdpAddToCartActive
                ? primaryNavigationHeight + secondaryNavigationHeight + 1 + addToCartHeight
                : headerHeight;
              break;
            case 'secondary-only':
              currentPrimaryNavigationHeight = 0;
              currentHeaderHeight = pdpAddToCartActive
                ? secondaryNavigationHeight + 1 + addToCartHeight
                : secondaryNavigationHeight;
              break;
            case 'pdp-contextual-only':
              currentPrimaryNavigationHeight = 0;
              currentHeaderHeight = addToCartHeight || secondaryNavigationHeight;
              break;
            case 'plp-hidden':
              currentPrimaryNavigationHeight = 0;
              currentHeaderHeight = secondaryNavigationHeight;
              break;
            case 'default-scroll':
            default:
              currentPrimaryNavigationHeight = Math.max(
                primaryNavigationHeight - Math.max(scrollY, 0),
                0
              );
              currentHeaderHeight = Math.max(
                headerHeight - Math.max(scrollY, 0),
                secondaryNavigationHeight
              );
              break;
          }
          document.body.style.setProperty(
            '--current-primary-navigation-height',
            `${currentPrimaryNavigationHeight}px`
          );
          document.body.style.setProperty('--current-header-height', `${currentHeaderHeight}px`);

          // `--current-secondary-nav-bottom` is the y-coord of the bottom of
          // the secondary nav bar in viewport space. Unlike `--current-header-height`,
          // it deliberately excludes the PDP add-to-cart bar, so elements like
          // the desktop navigation submenu can align with the bottom of the
          // secondary nav (overlaying the add-to-cart bar below).
          const currentSecondaryNavBottom = Math.max(
            offsetY + primaryNavigationHeight + secondaryNavigationHeight,
            0
          );
          document.body.style.setProperty(
            '--current-secondary-nav-bottom',
            `${currentSecondaryNavBottom}px`
          );
        };

        // rAF throttle: coalesce multiple scroll ticks into one frame so the
        // layout reads (getBoundingClientRect) and writes (CSS variables +
        // headerTranslateY) happen at most once per paint. Always processes
        // the latest scroll position so we never fall behind.
        let scrollRafId = null;
        let latestScrollArgs = null;
        const throttledScroll = (...args) => {
          latestScrollArgs = args;
          if (scrollRafId !== null) return;
          scrollRafId = requestAnimationFrame(() => {
            scrollRafId = null;
            onScroll(...latestScrollArgs);
          });
        };

        Motion.scroll(throttledScroll);
        onScroll();

        const onResize = () => {
          const secondaryNavigationContent = this.$refs.secondaryNavigationContent;
          const secondaryNavigationContentRect = secondaryNavigationContent.getBoundingClientRect();
          document.documentElement.style.setProperty(
            '--secondary-navigation-left',
            `${secondaryNavigationContentRect.left}px`
          );
        };

        window.addEventListener('resize', onResize);
        onResize();

        this.$watch('$store.breakpoints.isMobile', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  window.OrderTrackingComponent = function () {
    return {
      email: '',
      orderNumber: '',
      errorMessage: '',
      includingTaxesText: '',
      orderNotFoundText: '',
      failedToGetOrderText: '',
      isPending: false,
      order: null,
      orderQueryUnsubscribe: null,
      validator: null,
      init() {
        this.includingTaxesText = this.$el.dataset.includingTaxesText;
        this.orderNotFoundText = this.$el.dataset.orderNotFoundText;
        this.failedToGetOrderText = this.$el.dataset.failedToGetOrderText;

        this.validator = new JustValidate(this.$refs.form, {
          errorLabelStyle: {
            display: 'none',
          },
        });
        this.validator.addField('#email', [
          {
            rule: 'required',
            errorMessage: 'Email is required',
          },
          {
            rule: 'email',
            errorMessage: 'Invalid email',
          },
        ]);

        this.validator.addField('#orderNumber', [
          {
            rule: 'required',
            errorMessage: 'Order number is required',
          },
        ]);

        this.validator.onFail((errors) => {
          this.order = null;
          this.errorMessage = Object.values(errors)
            .map((error) => error.errorMessage)
            .join(', ');
        });

        this.validator.onSuccess((event) => {
          event?.preventDefault();
          this.lookupOrder();
        });
      },
      async lookupOrder() {
        const email = this.email.trim();
        const orderNumber = this.orderNumber.replace(/^#/, '').trim();

        this.errorMessage = '';
        this.order = null;
        this.orderQueryUnsubscribe?.();

        this.orderQueryUnsubscribe = window.query({
          key: ['order-tracking', orderNumber, email],
          fn: () => this.getOrder(orderNumber, email),
          subscribeFn: (result, unsubscribe) => {
            this.isPending = result.isPending;

            if (result.isSuccess) {
              this.order = result.data;
              this.errorMessage = '';
              unsubscribe?.();
              this.orderQueryUnsubscribe = null;
            }

            if (result.isError) {
              this.order = null;
              this.errorMessage = result.error?.message ?? this.failedToGetOrderText;
              unsubscribe?.();
              this.orderQueryUnsubscribe = null;
            }
          },
        });
      },
      async getOrder(orderNumber, email) {
        const params = new URLSearchParams({
          email,
          'order-number': orderNumber,
        });
        const response = await fetch(`${window.Shopify.routes.root}apps/api/order?${params.toString()}`);
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error(this.orderNotFoundText);
          }
          throw new Error(this.failedToGetOrderText);
        }
        const data = await response.json();
        return data.order;
      },
      displayPrice(price) {
        return new Intl.NumberFormat(window.Shopify.locale, { style: 'currency', currency: price.currencyCode }).format(
          price.amount
        );
      },
      displayIncludingTaxesText(taxAmount) {
        return this.includingTaxesText.replace('{ tax_amount }', this.displayPrice(taxAmount));
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString(window.Shopify.locale, {
          month: 'long',
          day: 'numeric',
        });
      },
      get buyAgainUrl() {
        const cartQuery = this.order.lineItems.edges
          .map((item) => `${item.node.variant.id.replace('gid://shopify/ProductVariant/', '')}:${item.node.quantity}`)
          .join(',');
        return `${window.Shopify.routes.root}cart/${cartQuery}`;
      },
      getFulfillmentStatusDate(fulfillment) {
        if (fulfillment.deliveryStatus === 'Delivered') {
          return fulfillment.deliveredAt;
        }
        if (fulfillment.deliveryStatus === 'In transit') {
          return fulfillment.inTransitAt;
        }
        return fulfillment.updatedAt;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-categories"] && !Shopify.designMode) return;
  try {
    
  window.ProductCategoriesComponent = function () {
    return {
      activeCategory: null,
      init: function () {
        const swiper = new Swiper(this.$refs.swiper, {
          slidesPerView: 1.3,
          freeMode: true,
          breakpoints: {
            640: { slidesPerView: 3.1 },
          },
          mousewheel: {
            forceToAxis: true,
          },
        });

        // Move the peek buttons toward the titles as this sticky section scrolls.
        // Cache static elements and measurements, then keep each frame to one
        // layout read followed by compositor-only transform writes.
        const titleEl = this.$el.querySelector('[data-title]');
        const peekButtonContainerEl = this.$el.querySelector('[data-peek-button-container]');
        const peekButtons = Array.from(this.$el.querySelectorAll('[data-peek-button]'));

        if (titleEl && peekButtonContainerEl && peekButtons.length) {
          let distanceFromPeekButtonToTitle = 0;
          let frameId = null;
          let lastTranslateY = null;

          const updatePeekButtons = () => {
            frameId = null;

            const containerTop = this.$el.getBoundingClientRect().top;
            const minimumTranslateY = -distanceFromPeekButtonToTitle + 10;
            const translateY = Math.min(0, Math.max(containerTop, minimumTranslateY));

            if (translateY === lastTranslateY) return;
            lastTranslateY = translateY;

            peekButtons.forEach((button) => {
              button.style.transform = `translate3d(0, ${translateY}px, 0)`;
            });
          };

          const queuePeekButtonUpdate = () => {
            if (frameId !== null) return;
            frameId = requestAnimationFrame(updatePeekButtons);
          };

          const measurePeekButtonDistance = () => {
            const titleRect = titleEl.getBoundingClientRect();
            const peekButtonContainerRect = peekButtonContainerEl.getBoundingClientRect();
            distanceFromPeekButtonToTitle = peekButtonContainerRect.top - titleRect.bottom;
            lastTranslateY = null;
            queuePeekButtonUpdate();
          };

          window.addEventListener('scroll', queuePeekButtonUpdate, { passive: true });
          window.addEventListener('resize', measurePeekButtonDistance, { passive: true });
          requestAnimationFrame(measurePeekButtonDistance);

          this.destroyPeekButtonScroll = () => {
            window.removeEventListener('scroll', queuePeekButtonUpdate);
            window.removeEventListener('resize', measurePeekButtonDistance);
            if (frameId !== null) cancelAnimationFrame(frameId);
          };
        }
      },
      destroy() {
        this.destroyPeekButtonScroll?.();
      },
      openCategory(category) {
        this.activeCategory = category;
        // The panel body is mounted by `panel.liquid`, so wait until Alpine has
        // inserted it before loading its product cards.
        this.$nextTick(() => {
          requestAnimationFrame(() => this.loadPanelProducts(category.index));
        });
      },
      async loadPanelProducts(index) {
        const panelEl = document.querySelector(`[data-product-categories-panel="${index}"]`);
        if (!panelEl || panelEl.dataset.productsLoaded === 'true' || panelEl.dataset.productsLoading === 'true') {
          return;
        }

        const loadingEl = panelEl.querySelector('[data-product-categories-panel-loading]');
        const errorEl = panelEl.querySelector('[data-product-categories-panel-error]');
        const swiperEl = panelEl.querySelector('[data-product-categories-panel-swiper-element]');
        const productsEl = panelEl.querySelector('[data-product-categories-panel-products]');

        try {
          panelEl.dataset.productsLoading = 'true';
          loadingEl.classList.remove('hidden');
          errorEl.classList.add('hidden');
          errorEl.classList.remove('flex');
          const handles = JSON.parse(panelEl.dataset.productHandles || '[]');
          if (!handles.length) throw new Error('No category products configured');

          const cards = await Promise.all(
            handles.map(async (handle) => {
              const url = `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}?section_id=product-category-card`;
              const response = await fetch(url);
              if (!response.ok) throw new Error(`Failed to load product ${handle}`);

              const html = await response.text();
              const card = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector('[data-product-category-card]');
              if (!card) throw new Error(`Missing product card for ${handle}`);
              return card;
            }),
          );

          productsEl.replaceChildren(...cards);
          loadingEl.classList.add('hidden');
          swiperEl.classList.remove('hidden');
          panelEl.dataset.productsLoaded = 'true';
          this.initPanelSwiper(panelEl);
        } catch (error) {
          console.error('[ProductCategoriesComponent] Failed to load category products', error);
          loadingEl.classList.add('hidden');
          errorEl.classList.remove('hidden');
          errorEl.classList.add('flex');
        } finally {
          panelEl.dataset.productsLoading = 'false';
        }
      },
      initPanelSwiper(panelEl) {
        const swiperContainerEl = panelEl.querySelector('[data-product-categories-panel-swiper]');
        if (!swiperContainerEl || swiperContainerEl.dataset.swiperInitialized === 'true') return;

        const swiperEl = swiperContainerEl.querySelector('[data-product-categories-panel-swiper-element]');
        const prevButtonEl = swiperContainerEl.querySelector('[data-navigation-button="prev"]');
        const nextButtonEl = swiperContainerEl.querySelector('[data-navigation-button="next"]');
        if (!swiperEl || !prevButtonEl || !nextButtonEl) return;

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 2.2,
          spaceBetween: 5,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          breakpoints: {
            640: { slidesPerView: 1.9, slidesOffsetBefore: 45, slidesOffsetAfter: 45 },
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        prevButtonEl.addEventListener('click', () => swiper.slidePrev());
        nextButtonEl.addEventListener('click', () => swiper.slideNext());
        swiperContainerEl.dataset.swiperInitialized = 'true';
      },
      closePanel() {
        this.activeCategory = null;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  window.ProductGalleryComponent = function ({ hasProductHero }) {
    return {
      showVariantImage: false,
      activeImage: null,
      mobileSwiper: null,
      mobileVariantImageAnimation: null,
      productActionsRootHeight: null,
      productSidebarStickyDisabled: false,
      productSidebarStickyRafId: null,
      productSidebarStickyResizeListener: null,
      init: function () {
        const slideCount = this.$refs.gallerySwiperContainer.querySelectorAll('.swiper-slide').length;
        this.mobileSwiper = new Swiper(this.$refs.gallerySwiperContainer, {
          slidesPerView: slideCount <= 1 ? 1 : 1.2,
          spaceBetween: 5,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        this.$watch('$store.product.selectedVariant', (variant) => {
          if (variant) {
            if (this.$store.breakpoints.isMobile) {
              // mobile variant image animation
              const selectedVariantMediaID = String(variant.featured_media?.id ?? variant.featured_image?.id ?? '');
              if (!selectedVariantMediaID) return;
              const slides = this.mobileSwiper.slides;
              const selectedVariantImageSlide = slides.find((slide) => slide.id === selectedVariantMediaID);
              const selectedVariantImageSlideIndex = selectedVariantImageSlide
                ? this.mobileSwiper.slides.indexOf(selectedVariantImageSlide)
                : -1;

              if (selectedVariantImageSlideIndex !== -1) {
                this.mobileSwiper.slideTo(selectedVariantImageSlideIndex);
                for (const slide of slides) {
                  slide.children[0]?.classList?.remove?.('!border-black/60');
                }
                selectedVariantImageSlide.children[0]?.classList?.add?.('!border-black/60');
              }
            } else {
              // desktop variant image animation
              if (!this.showVariantImage) {
                this.showVariantImage = true;
                this.$store.product.showPersonalizationInput = false;
                this.$root.scrollIntoView({ behavior: 'auto' });
                const galleryContainerWidth = this.$refs.galleryContainer.getBoundingClientRect().width;
                const variantImageAspectRatio = variant.featured_image.width / variant.featured_image.height;
                const variantImageContainerHeight = galleryContainerWidth / variantImageAspectRatio;
                Motion.animate(
                  this.$refs.galleryContainer,
                  {
                    height: variantImageContainerHeight,
                  },
                  {
                    duration: 0.15,
                    ease: 'easeOut',
                  }
                ).then(() => {
                  this.$refs.galleryContainer.style.height = 'auto';
                  this.$refs.variantImageContainer.style.position = 'static';
                });
              }
            }
          }

          this.$nextTick(() => this.queueProductSidebarStickyUpdate());
        });

        const onResize = () => {
          if (this.$store.breakpoints.isMobile) {
            this.showVariantImage = false;
          }
          this.updateProductSidebarStickyState();
        };
        this.productSidebarStickyResizeListener = onResize;
        window.addEventListener('resize', onResize);
        window.visualViewport?.addEventListener('resize', onResize);
        this.$watch('productActionsRootHeight', () => {
          this.updateProductSidebarStickyState();
        });

        this.$watch('activeImage', (image) => {
          if (image) {
            this.$store.settings.enableBodyScrollLock();
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
      destroy: function () {
        if (this.productSidebarStickyResizeListener) {
          window.removeEventListener('resize', this.productSidebarStickyResizeListener);
          window.visualViewport?.removeEventListener('resize', this.productSidebarStickyResizeListener);
          this.productSidebarStickyResizeListener = null;
        }
        if (this.productSidebarStickyRafId !== null) {
          cancelAnimationFrame(this.productSidebarStickyRafId);
          this.productSidebarStickyRafId = null;
        }
      },
      queueProductSidebarStickyUpdate: function () {
        if (this.productSidebarStickyRafId !== null) return;
        this.productSidebarStickyRafId = requestAnimationFrame(() => {
          this.productSidebarStickyRafId = null;
          this.updateProductSidebarStickyState();
        });
      },
      updateProductSidebarStickyState: function () {
        if (!this.productActionsRootHeight) return;

        const isDesktopLayout = window.matchMedia('(min-width: 640px)').matches;
        if (!isDesktopLayout) {
          this.productSidebarStickyDisabled = false;
          return;
        }

        // Vertical breathing room around the sticky card so it isn't flush
        // against the header/viewport edges. Matches the right column's
        // `sm:py-7` (28px top + 28px bottom).
        const RIGHT_COLUMN_VERTICAL_PADDING = 56;

        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const stickyTop = this.getProductSidebarStickyTop();
        const requiredHeight = this.productActionsRootHeight + RIGHT_COLUMN_VERTICAL_PADDING;
        const availableHeight = viewportHeight - stickyTop;

        this.productSidebarStickyDisabled = requiredHeight > availableHeight;
      },
      getProductSidebarStickyTop: function () {
        const stickyTop = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--secondary-navigation-height')
        );

        return Number.isFinite(stickyTop) ? stickyTop : 0;
      },
      centerZoomImageModal: function (modal) {
        if (!modal) return;

        const centerModal = () => {
          const maxScrollTop = modal.scrollHeight - modal.clientHeight;
          modal.scrollTop = maxScrollTop > 0 ? maxScrollTop / 2 : 0;
        };

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            centerModal();

            const image = modal.querySelector('img');
            if (image && !image.complete) {
              image.addEventListener('load', centerModal, { once: true });
            }
          });
        });
      },
      get variantImageSrc() {
        return this.showVariantImage && this.$store.product.selectedVariant
          ? this.$store.product.selectedVariant.featured_image.src
          : undefined;
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-listing"] && !Shopify.designMode) return;
  try {
    
  window.CategoryListingComponent = function (productsCount, rowFilterParamName, showRowFilter, showProductFinder) {
    return {
      rowFilterParamName: rowFilterParamName,
      numberOfProducts: productsCount,
      isFiltersOpen: false,
      isFilteredProductGridOpen: false,
      sortBy: null,
      // These are the unapplied sort by used on mobile when the user changes sort by but not apply them yet.
      unappliedSortBy: null,
      filters: [],
      // These are the unapplied filter values used on mobile when the user changes filters but not apply them yet.
      unappliedFilters: [],
      filterParamNames: [],
      isCompareOpen: false,
      isFinderOpen: false,
      // filter result
      fetchFilterResultMutation: null,
      newFilterResult: null,
      isPending: false,
      isSuccess: true,
      isError: false,
      error: null,
      init() {
        // set the row filter data in the settings store
        this.$store.hasRowFilter = !!showRowFilter;

        // Row filter height is measured once at init (and on resize) so we
        // can publish `--plp-sticky-content-top` to the document for sticky
        // content (like product-highlight text) that needs to sit below the
        // pinned row filter instead of being overlapped by it.
        let rowFilterHeight = 0;
        let rowFilterEl = null;
        const measureRowFilter = () => {
          rowFilterEl = this.$root.querySelector('[data-row-filter]');
          if (rowFilterEl) rowFilterHeight = rowFilterEl.getBoundingClientRect().height;
        };

        const updatePlpStickyContentTop = () => {
          if (!this.$store.hasRowFilter || rowFilterHeight <= 0) return;
          const headerHeightValue = parseFloat(
            getComputedStyle(document.body).getPropertyValue('--current-header-height')
          );
          const currentHeaderHeight = Number.isFinite(headerHeightValue) ? headerHeightValue : 0;
          const rowFilterTop = this.$store.settings.mainNavRevealed
            ? currentHeaderHeight + 5 // 0.3125rem gap below header
            : 0;
          document.body.style.setProperty(
            '--plp-sticky-content-top',
            `${rowFilterTop + rowFilterHeight + 20}px` // 1.25rem gap below the row filter
          );
        };

        const onResize = () => {
          this.$store.distanceFromRowFilterTopToPageTop =
            this.$refs.rowFilterPlaceholder.getBoundingClientRect().top -
            document.documentElement.getBoundingClientRect().top;
          measureRowFilter();
          updatePlpStickyContentTop();
        };
        window.addEventListener('resize', onResize);
        this.$nextTick(() => {
          measureRowFilter();
          updatePlpStickyContentTop();
        });
        onResize();

        const onScroll = () => {
          if (this.$store.hasRowFilter) {
            this.$store.settings.rowFilterStickyStarted =
              this.$refs.rowFilterPlaceholder.getBoundingClientRect().top < 0;
            updatePlpStickyContentTop();

            // Detect when the row filter has scrolled off the top (the
            // user has reached the end of the products-listing section).
            // Once that happens the contextual sticky bar is no longer on
            // screen, so the header is free to show the secondary nav
            // again regardless of scroll direction.
            if (rowFilterEl) {
              this.$store.settings.rowFilterExited = rowFilterEl.getBoundingClientRect().bottom <= 0;
            }
          }
        };

        // Batch scroll work into one rAF per frame so reads/writes don't
        // happen multiple times per paint when the browser fires scroll
        // events faster than it repaints.
        let scrollRafId = null;
        const throttledScroll = () => {
          if (scrollRafId !== null) return;
          scrollRafId = requestAnimationFrame(() => {
            scrollRafId = null;
            onScroll();
          });
        };
        Motion.scroll(throttledScroll);
        onScroll();

        // Re-publish when the main nav reveal state flips, so the sticky
        // offset lines up with the row filter's animated new position.
        this.$watch('$store.settings.mainNavRevealed', () => updatePlpStickyContentTop());

        // get the initial filter values
        this.getInitialFilters();

        // filter out featured products and product highlights, then correct the order of the email subscription card
        const emailSubscriptionCard = this.$root.querySelector('[data-email-subscription-card]');
        const featuredProductsCards = document.querySelectorAll('[data-product-featured-card-id]');
        const productHighlights = document.querySelectorAll('[data-product-highlight-id]');
        const featuredProductIds = new Set(
          [...(featuredProductsCards ?? []), ...(productHighlights ?? [])].map(
            (element) => element.dataset.productFeaturedCardId
          )
        );
        if (featuredProductIds) {
          let count = 0;
          Array.from(featuredProductIds).forEach((id) => {
            if (id) {
              const productCard = this.$refs.productGridContainer.querySelector(`[data-product-grid-item-id="${id}"]`);
              if (productCard) {
                productCard.style.display = 'none';
                count++;
              }
            }
          });

          if (emailSubscriptionCard && count > 0) {
            const order = parseInt(emailSubscriptionCard.dataset.order);
            if (Number.isInteger(order)) {
              const newOrder = order + count * 10;
              emailSubscriptionCard.style['--email-subscription-order'] = newOrder;
            }
          }
        }

        this.fetchFilterResultMutation = window.createMutation({
          mutationFn: async (onlySetUnappliedValues) => {
            const url = this.generateNewURL();
            const params = url.searchParams;
            params.set('sections', 'product-grid-section,filters-data-section');
            const response = await fetch(url);
            if (!response.ok) {
              throw new Error('Failed to applied filters');
            }
            return { data: await response.json(), onlySetUnappliedValues };
          },
          subscribeFn: (result, unsubscribe) => {
            this.newFilterResult = null;
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.error = result.error;

            if (result.isSuccess) {
              const data = result.data.data;
              const onlySetUnappliedValues = result.data.onlySetUnappliedValues;
              this.getFiltersData(
                new DOMParser()
                  .parseFromString(data['filters-data-section'], 'text/html')
                  .querySelector('#filters-data'),
                onlySetUnappliedValues
              );
              if (!onlySetUnappliedValues) this.renderProductGrid(data);
            }
          },
        });

        this.$watch('$store.breakpoints.isMobile', (isMobile) => {
          if (!isMobile) {
            this.isFilteredProductGridOpen = this.hasAnyFilterActive();
            this.isFiltersOpen = this.hasAnyFilterActive(true);
          }
        });

        this.alignDesktopFilterAndSortAccordionsHeight();
      },
      alignDesktopFilterAndSortAccordionsHeight() {
        // align the desktop filter and sort accordions container's height with the desktop filter and sort accordions placeholder's height.
        const desktopFilterAndSortAccordionsContainer = this.$refs.desktopFilterAndSortAccordionsContainer;
        const desktopFilterAndSortAccordionsPlaceholder = this.$refs.desktopFilterAndSortAccordionsPlaceholder;
        const desktopFilterAndSortAccordionsPlaceholder2 = this.$refs.desktopFilterAndSortAccordionsPlaceholder2;
        const resizeObserver = new ResizeObserver((entries) => {
          const desktopFilterAndSortAccordionsContainerHeight = entries[0].contentRect.height;
          const desktopFilterAndSortAccordionsPlaceholderHeight =
            desktopFilterAndSortAccordionsPlaceholder.getBoundingClientRect().height;
          const desktopFilterAndSortAccordionsPlaceholder2Height =
            desktopFilterAndSortAccordionsPlaceholder2.getBoundingClientRect().height;
          if (desktopFilterAndSortAccordionsContainerHeight !== desktopFilterAndSortAccordionsPlaceholderHeight) {
            desktopFilterAndSortAccordionsPlaceholder.style.height = `${desktopFilterAndSortAccordionsContainerHeight}px`;
          }
          if (desktopFilterAndSortAccordionsContainerHeight !== desktopFilterAndSortAccordionsPlaceholder2Height) {
            desktopFilterAndSortAccordionsPlaceholder2.style.height = `${desktopFilterAndSortAccordionsContainerHeight}px`;
          }
        });
        resizeObserver.observe(desktopFilterAndSortAccordionsContainer);
      },
      // helper functions
      getFilter(filterValues, filterLabel) {
        if (!Array.isArray(filterValues)) return null;
        return filterValues.find((filter) => filter.label === filterLabel);
      },
      getFilterValue(filterValues, filterLabel, value) {
        return this.getFilter(filterValues, filterLabel)?.values.find((filterValue) => filterValue.value === value);
      },
      getFilterValueActiveStatus(filterValues, filterLabel, value) {
        return !!this.getFilterValue(filterValues, filterLabel, value)?.active;
      },
      isRowFilter(filter) {
        return filter?.paramName === this.rowFilterParamName;
      },
      getFilterTotalCount(filterLabel) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilter(targetFilterValues, filterLabel)?.values.reduce((total, value) => total + value.count, 0);
      },
      toggleFilterValueActiveStatus(filterValues, filterLabel, value) {
        const filterValue = this.getFilterValue(filterValues, filterLabel, value);
        if (filterValue?.active) {
          filterValue.active = false;
        } else {
          filterValue.active = true;
        }
      },
      // initialize the filter values and sort by
      getFiltersData(el, onlySetUnappliedValues = false) {
        if (el?.textContent) {
          try {
            const filtersData = JSON.parse(el.textContent);
            const parsedFilters = Array.isArray(filtersData.filters) ? filtersData.filters : [];
            const parsedSortBy = filtersData.sort_by ?? null;

            if (!onlySetUnappliedValues) {
              this.filters = parsedFilters;
              this.sortBy = parsedSortBy;
              this.unappliedFilters = structuredClone(Alpine.raw(this.filters));
              this.unappliedSortBy = this.sortBy;
            } else {
              // On mobile, keep applied values untouched and refresh only unapplied state.
              this.unappliedFilters = structuredClone(parsedFilters);
              this.unappliedSortBy = parsedSortBy;
            }
          } catch (error) {
            console.error('[ProductsListingComponent] Invalid filters data', error);
          }
        }
      },
      getInitialFilters() {
        const filtersDataEl = this.$root.querySelector('#filters-data');
        this.getFiltersData(filtersDataEl);

        const hasFiltersApplied = this.hasAnyFilterActive();
        const hasNonRowFiltersApplied = this.hasAnyFilterActive(true);
        if (hasFiltersApplied) {
          this.isFilteredProductGridOpen = true;
          if (!this.$store.breakpoints.isMobile && hasNonRowFiltersApplied) {
            this.isFiltersOpen = true;
          }
        }
      },
      onDesktopFilterButtonClick() {
        if (this.isFiltersOpen) {
          this.isFiltersOpen = false;
          this.isFilteredProductGridOpen = false;
          this.clearAllFilters();
        } else {
          this.isFiltersOpen = true;
          this.isFilteredProductGridOpen = true;
        }
      },
      onMobileFilterButtonClick() {
        this.isFiltersOpen = true;
      },
      getFilterValueCount(filterLabel, value) {
        const filterValue = parseInt(this.getFilterValue(this.filters, filterLabel, value)?.count);
        return parseInt(this.getFilterValue(this.filters, filterLabel, value)?.count) ?? 0;
      },
      getUnifiedFilterValueCount(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return parseInt(this.getFilterValue(targetFilterValues, filterLabel, value)?.count) ?? 0;
      },
      isFilterValueActive(filterLabel, value) {
        return this.getFilterValue(this.filters, filterLabel, value)?.active;
      },
      isUnappliedFilterValueActive(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilterValueActiveStatus(targetFilterValues, filterLabel, value);
      },
      isUnifiedFilterValueActive(filterLabel, value) {
        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        return this.getFilterValueActiveStatus(targetFilterValues, filterLabel, value);
      },
      hasAnyFilterActive(excludeRowFilter = false) {
        return (
          this.filters.some((filter) => {
            if (excludeRowFilter && this.isRowFilter(filter)) return false;
            return filter.values.some((value) => value.active);
          }) || this.sortBy
        );
      },
      generateNewURL() {
        const newURL = new URL(window.location.href);
        const params = newURL.searchParams;
        const targetSortBy = this.$store.breakpoints.isMobile ? this.unappliedSortBy : this.sortBy;
        if (targetSortBy) {
          params.set('sort_by', targetSortBy);
        } else {
          params.delete('sort_by');
        }

        const targetFilterValues = this.$store.breakpoints.isMobile ? this.unappliedFilters : this.filters;
        targetFilterValues.forEach((filter) => {
          const values = filter?.values;
          const key = filter?.paramName;
          if (!key) return;
          params.delete(key);
          if (values?.length > 0) {
            values.forEach((value) => {
              if (value.active) {
                params.append(key, value.value);
              }
            });
          }
        });
        return newURL;
      },
      updateURL(newURL) {
        window.history.replaceState(null, '', newURL.toString());
      },
      renderProductGrid(result) {
        // render the product grid
        const html = new DOMParser()
          .parseFromString(result['product-grid-section'], 'text/html')
          .querySelector('#product-grid');
        const numberOfProducts = html.children.length;
        this.numberOfProducts = numberOfProducts;

        const container = this.$refs.categoryListingContainer.querySelector('#product-grid-container');
        container.innerHTML = '';
        container.appendChild(html);
      },
      onFilterChange(filterLabel, value) {
        this.toggleFilterValueActiveStatus(this.filters, filterLabel, value);
        // reset the unapplied filter values and sort by when the actual filter values are changed
        this.unappliedFilters = structuredClone(Alpine.raw(this.filters));
        this.unappliedSortBy = this.sortBy;

        this.updateURL(this.generateNewURL());

        this.fetchFilterResultMutation.mutate();
      },
      onUnappliedFilterChange(filterLabel, value) {
        this.toggleFilterValueActiveStatus(this.unappliedFilters, filterLabel, value);
        this.fetchFilterResultMutation.mutate(true);
      },
      onUnifiedFilterChange(filterLabel, value) {
        if (this.$store.breakpoints.isMobile) {
          this.onUnappliedFilterChange(filterLabel, value);
        } else {
          this.onFilterChange(filterLabel, value);
        }
      },
      isSortByValueActive(value) {
        const targetSortBy = this.$store.breakpoints.isMobile ? this.unappliedSortBy : this.sortBy;
        return targetSortBy === value;
      },
      onSortByChange(value, activeLabel) {
        if (this.$store.breakpoints.isMobile) {
          this.unappliedSortBy = value;
        } else {
          this.sortBy = value;
          // reset the unapplied sort by when the actual sort by is changed
          this.unappliedSortBy = value;
        }

        if (!this.$store.breakpoints.isMobile) this.updateURL(this.generateNewURL());

        this.fetchFilterResultMutation.mutate(this.$store.breakpoints.isMobile);
      },
      applyFilters() {
        this.filters = structuredClone(Alpine.raw(this.unappliedFilters));
        this.sortBy = this.unappliedSortBy;

        this.updateURL(this.generateNewURL());
        this.fetchFilterResultMutation.mutate();

        this.closeMobileFilterPanel();
      },
      closeMobileFilterPanel() {
        this.isFiltersOpen = false;
        if (!this.hasAnyFilterActive()) {
          this.isFilteredProductGridOpen = false;
        } else {
          this.isFilteredProductGridOpen = true;
        }
      },
      clearAllFilters() {
        if (!this.$store.breakpoints.isMobile) {
          this.sortBy = null;
          this.filters.forEach((filter) => {
            if (this.isRowFilter(filter)) return;
            filter.values.forEach((value) => {
              value.active = false;
            });
          });
        }

        this.unappliedSortBy = null;
        this.unappliedFilters.forEach((filter) => {
          if (this.isRowFilter(filter)) return;
          filter.values.forEach((value) => {
            value.active = false;
          });
        });

        if (!this.$store.breakpoints.isMobile) {
          this.updateURL(this.generateNewURL());
        }

        this.fetchFilterResultMutation.mutate(this.$store.breakpoints.isMobile);
      },
      get isPanelOpen() {
        return this.isFiltersOpen && this.$store.breakpoints.isMobile;
      },
      set isPanelOpen(value) {
        if (!value) this.closeMobileFilterPanel();
        else this.onMobileFilterButtonClick();
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  window.RecentlyViewedComponent = function () {
    return {
      init: async function () {
        const STORAGE_KEY = 'shopify-recently-viewed';
        const MAX_ITEMS = 6;
        const recentlyViewedContainer = this.$refs.recentlyViewedContainer;
        const currentProductHandle = recentlyViewedContainer.dataset.currentProductHandle;
        const listContainer = this.$refs.listContainer;
        const listContainerMobile = this.$refs.listContainerMobile;
        const swiperContainer = this.$refs.swiperContainer;
        let swiper = null;

        trackCurrentProduct();
        await displayRecentProducts();

        window.addEventListener('storage', async function (event) {
          if (event.key === STORAGE_KEY) {
            await displayRecentProducts();
          }
        });

        function getRecentHandles() {
          const storedValue = localStorage.getItem(STORAGE_KEY);
          try {
            return storedValue ? JSON.parse(storedValue) : [];
          } catch (error) {
            console.error('Error parsing recently viewed products:', error);
            return [];
          }
        }

        function saveRecentHandles(handles) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
        }

        function trackCurrentProduct() {
          if (!currentProductHandle) {
            return; // Not a product page or handle is missing
          }

          let handles = getRecentHandles();
          // Remove the handle if it already exists to move it to the front
          handles = handles.filter((h) => h !== currentProductHandle);
          // Add the new handle to the beginning of the array
          handles.unshift(currentProductHandle);
          // Trim the array to the maximum allowed size
          const trimmedHandles = handles.slice(0, MAX_ITEMS);
          saveRecentHandles(trimmedHandles);
        }

        async function displayRecentProducts() {
          const handles = getRecentHandles();

          const fetchPromises = handles.map((handle) =>
            fetch(`${window.Shopify.routes.root}products/${handle}?sections=recently-viewed-product-card`).then(
              async (response) => {
                if (response.ok) {
                  const responseData = await response.json();
                  const html = responseData['recently-viewed-product-card'];
                  const dom = new DOMParser().parseFromString(html, 'text/html');
                  const desktopContent = dom.querySelector('#recently-viewed-product-card-desktop');
                  const mobileContent = dom.querySelector('#recently-viewed-product-card-mobile');
                  const data = {
                    desktop: desktopContent,
                    mobile: mobileContent,
                  };
                  return data;
                }
                return null;
              }
            )
          );

          const products = (await Promise.all(fetchPromises)).filter(Boolean);
          if (products.length > 0) {
            listContainerMobile.innerHTML = '';
            listContainer.innerHTML = '';
            for (const product of products) {
              recentlyViewedContainer.classList.remove('hidden');
              listContainerMobile.appendChild(product.mobile);
              listContainer.appendChild(product.desktop);
            }

            initSwiper();
          } else {
            recentlyViewedContainer.classList.add('hidden');
          }
        }

        function initSwiper() {
          if (swiper) {
            swiper.destroy(true, true);
          }
          swiper = new Swiper(swiperContainer, {
            slidesPerView: 3,
            spaceBetween: 5,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  window.SearchComponent = function (noResultsText) {
    return {
      open: false,
      hasOpened: false,
      noResultsText: noResultsText,
      searchTerm: '',
      searchResults: null,
      querySuggestions: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      error: null,
      init() {
        const button = document.getElementById('header-search-button');
        button.addEventListener('click', () => {
          this.openModal();
        });

        this.$watch('open', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.enableBodyScrollLock();
            setTimeout(() => {
              this.$refs.input.focus();
            }, 100);
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
      openModal() {
        this.hasOpened = true;
        this.open = true;
      },
      closeModal() {
        this.open = false;
      },
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      },
      onChange() {
        const searchTerm = this.$refs.input.value.trim();
        this.searchTerm = searchTerm;

        if (searchTerm.length === 0) {
          this.querySuggestions = null;
          this.searchResults = null;
          this.isSuccess = false;
          this.isError = false;
          this.isPending = false;
          this.error = null;
          return;
        }

        window.query({
          key: ['searchResults', searchTerm],
          fn: () => this.getSearchResults(searchTerm),
          subscribeFn: (result, unsubscribe) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.error = result.error;

            if (result.isSuccess) {
              const searchResultsContainer = new DOMParser()
                .parseFromString(result.data, 'text/html')
                .querySelector('#shopify-section-predictive-search');
              this.searchResults = searchResultsContainer.querySelector('#search-results').innerHTML;
              this.querySuggestions = searchResultsContainer.querySelector('#query-suggestions').innerHTML;
            }
            if (result.isError) {
              this.error = result.error;
            }
            if (result.isSuccess || result.isError) {
              unsubscribe?.();
            }
          },
        });
      },
      async getSearchResults(searchTerm) {
        const fields = [
          'author',
          'body',
          'product_type',
          'tag',
          'title',
          'variants.barcode',
          'variants.sku',
          'variants.title',
          'vendor',
        ].join(',');
        const params = new URLSearchParams({
          q: searchTerm,
          'resources[type]': 'product,collection,article,page,query',
          'resources[options][fields]': fields,
          section_id: 'predictive-search',
        });
        const response = await fetch(`${window.Shopify.routes.root}search/suggest?${params.toString()}`);
        if (!response.ok) {
          throw new Error('Failed to fetch search results');
        }

        const text = await response.text();
        return text;
      },
      onSuggestionClick(term) {
        this.$refs.input.value = term;
        this.onChange();
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  window.StoreLocatorComponent = function (pinUrl) {
    const mapData = {
      markers: [],
      map: null,
      storesData: [],
      markerCluster: null,
    };
    return {
      rawSelectedCountry: null,
      rawSelectedCity: null,
      selectedStore: null,
      init: function () {
        // Parse store data from data attribute
        mapData.storesData = JSON.parse(this.$refs.data.textContent).stores;

        // Load Google Maps API
        this.initializeMap();

        this.$watch('filteredStores', async (filteredStores) => {
          const markers = mapData.markers.filter((marker) =>
            filteredStores.some((store) => store.id === marker.store.id)
          );
          await this.updateMarkers(markers);
          await this.updateBounds(markers);
        });
      },
      initializeMap: async function () {
        if (mapData.map) return;
        const defaultCenter = { lat: 56.2, lng: 9.5 };
        const MapLibrary = await google.maps.importLibrary('maps');
        const MarkerLibrary = await google.maps.importLibrary('marker');
        mapData.map = new MapLibrary.Map(this.$refs.mapContainer, {
          center: defaultCenter,
          zoom: 6,
          styles: this.mapStyles,
          disableDefaultUI: true,
        });

        mapData.storesData.forEach((store) => {
          if (store.latitude && store.longitude) {
            const marker = new MarkerLibrary.Marker({
              position: { lat: parseFloat(store.latitude), lng: parseFloat(store.longitude) },
              icon: {
                url: pinUrl,
              },
            });
            marker.store = store;

            marker.addListener('click', () => {
              this.selectStore(store);
            });
            mapData.markers.push(marker);
          }
        });

        await this.updateMarkers(mapData.markers);
        await this.updateBounds(mapData.markers);
      },
      updateMarkers: async function (markers) {
        const MarkerLibrary = await google.maps.importLibrary('marker');

        if (mapData.markerCluster) {
          mapData.markerCluster.clearMarkers();
          mapData.markerCluster.addMarkers(markers);
        } else {
          mapData.markerCluster = new markerClusterer.MarkerClusterer({
            map: mapData.map,
            markers: markers,
            renderer: {
              render: ({ count, position, markers }) => {
                return new MarkerLibrary.Marker({
                  position: position,
                  icon: {
                    url: pinUrl,
                  },
                  label: {
                    text: count.toString(),
                    fontSize: '1rem',
                    className: 'translate-y-[-150%]',
                    fontWeight: 'bold',
                  },
                });
              },
            },
          });
        }
      },
      updateBounds: async function (markers) {
        const coreLibrary = await google.maps.importLibrary('core');
        // Create an empty LatLngBounds object
        const bounds = new coreLibrary.LatLngBounds();

        // Extend the bounds to include each point
        markers.forEach((marker) => {
          const position = marker.getPosition();
          if (!position) return;
          const point = new coreLibrary.LatLng(position.lat(), position.lng());
          bounds.extend(point);
        });

        mapData.map.fitBounds(bounds);
      },
      selectStore: function (store, scroll = true) {
        this.selectedStore = store;
        const marker = mapData.markers.find((m) => m.store.id === store.id);
        if (marker) {
          mapData.map.setCenter(marker.getPosition());
          mapData.map.setZoom(17);
        }
        if (scroll) {
          const storeListItem = document.querySelector(`[data-store-list-item][data-store-id="${store.id}"]`);
          const distanceFromTop = Math.abs(
            storeListItem.getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top
          );
          window.scrollTo({ top: distanceFromTop - 200, behavior: 'smooth' });
        }
      },

      get selectedCountry() {
        return this.rawSelectedCountry;
      },

      set selectedCountry(country) {
        this.rawSelectedCountry = country;
        this.selectedCity = null;
        this.selectedStore = null;
      },

      get selectedCity() {
        return this.rawSelectedCity;
      },

      set selectedCity(city) {
        this.rawSelectedCity = city;
        this.selectedStore = null;
      },

      get countries() {
        const uniqueCountries = [...new Set(mapData.storesData.map((store) => store.country))];
        return uniqueCountries.filter((c) => c).sort();
      },

      get cities() {
        if (!this.selectedCountry) return [];
        const citiesInCountry = mapData.storesData
          .filter((store) => store.country === this.selectedCountry)
          .map((store) => store.city);
        return [...new Set(citiesInCountry)].filter((c) => c).sort();
      },

      get filteredStores() {
        return mapData.storesData.filter((store) => {
          if (this.selectedCountry && this.selectedCountry !== 'None' && store.country !== this.selectedCountry) {
            return false;
          }
          if (this.selectedCity && this.selectedCity !== 'None' && store.city !== this.selectedCity) {
            return false;
          }
          return true;
        });
      },
      mapStyles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
      ],
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  window.WishlistComponent = function () {
    return {
      activeMenuItem: 'wishlist',
    };
  };

  } catch(e) { console.error(e); }
})();
})();
